import './travel-detail-highlights.scss';
import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

class TravelDetailHighlights {
    constructor (element) {
        this.$travelDetailHighlights = element;
        this.$prevButton = this.$travelDetailHighlights.querySelector('.swiper-button-prev');
        this.$nextButton = this.$travelDetailHighlights.querySelector('.swiper-button-next');
        this.$pagination = this.$travelDetailHighlights.querySelector('.swiper-pagination');
        this.slider = null;
        this.$sliderContainer = this.$travelDetailHighlights.querySelector('[data-travel-detail-highlights="slider"]');
    }

    initialize () {
        if (this.$sliderContainer) {
            this.checkSize();
            this.setEvents();
        }
    }

    setEvents () {
        [768, 320].forEach((bp) => {
            window.mediaMatch[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    checkSize () {
        if (window.mediaMatch[768].matches) {
            if (this.slider !== null) {
                this.destroySlider();
            }
        } else {
            if (this.slider === null) {
                this.initSlider();
            }
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$sliderContainer, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 'auto',
            speed: 500,
            resistanceRatio: 0,
            autoHeight: false,
            pagination: {
                el: this.$pagination,
                type: 'progressbar',
                clickable: false
            },
            keyboard: true,
            a11y: {
                prevSlideMessage: window.translations.slider.prevSlideMessage,
                nextSlideMessage: window.translations.slider.nextSlideMessage,
                firstSlideMessage: window.translations.slider.firstSlideMessage,
                lastSlideMessage: window.translations.slider.lastSlideMessage,
                slideLabelMessage: window.translations.slider.slideLabelMessage
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            }
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { TravelDetailHighlights };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$travelDetailHighlights = $context.querySelectorAll('[data-travel-detail-highlights="root"]');
        for (let i = 0; i < $$travelDetailHighlights.length; i++) {
            if ($$travelDetailHighlights[i].querySelector('[data-travel-detail-highlights="slider"]')) {
                const travelDetailHighlightsAPI = new TravelDetailHighlights($$travelDetailHighlights[i]);
                travelDetailHighlightsAPI.initialize();
            }
        }
    }
});
